<template>
  <h2 class="pb-2 border-bottom">General Primary Care Services</h2>
  <h3>Primary Care / Pediatric</h3>

  <h4>Prevention & Wellness</h4>
  <ul>
    <li>Routine checkups & preventive care — regular visits to stay ahead of health issues.</li>
    <li>Annual physical exams — complete evaluations to track your overall health.</li>
    <li>Wellness visits — personalized plans to support a healthier lifestyle.</li>
    <li>Vaccinations & immunizations — protection for children and adults at every stage.</li>
    <li>School physicals — required checkups to keep kids safe and ready for school.</li>
  </ul>

  <h3>Chronic Condition Management</h3>
  <ul>
    <li>Diabetes management — ongoing monitoring and treatment to control blood sugar.</li>
    <li>Hypertension control — personalized care to manage blood pressure effectively.</li>
    <li>Thyroid disorders — diagnosis and treatment for hypothyroidism, hyperthyroidism, and related issues.</li>
    <li>High cholesterol — plans to reduce cardiovascular risk and improve wellness.</li>
    <li>Obesity & weight management — safe, supervised programs to reach and maintain healthy weight.</li>
  </ul>

  <h3>General Medical Care</h3>
  <ul>
    <li>Health screenings (blood pressure, cholesterol, diabetes, etc.) — early detection saves lives.</li>
    <li>Acute care & sick visits — quick relief for colds, flu, infections, and more.</li>
    <li>Minor injuries & wound care — fast, safe treatment for everyday accidents.</li>
    <li>Allergies & asthma care — diagnosis and management for lasting relief.</li>
    <li>Headaches & migraines — evaluation and treatment to improve quality of life.</li>
  </ul>

  <h3>Women’s Health</h3>
  <ul>
    <li>Women’s health exams — routine and preventive care for all stages of life.</li>
    <li>Birth control counseling — safe, informed choices tailored to your needs.</li>
    <li>Menopause management — easing symptoms and improving comfort.</li>
    <li>PCOS & thyroid care — comprehensive treatment plans for hormonal balance.</li>
  </ul>

  <h3>Men’s Health</h3>
  <ul>
    <li>Men’s health programs — preventive and specialized care for male patients.</li>
    <li>Prostate health screening — early detection for peace of mind.</li>
    <li>Erectile dysfunction treatment — safe, medical solutions with discretion.</li>
    <li>Testosterone replacement therapy (TRT) — supervised therapy to restore vitality.</li>
  </ul>

  <h3>Hormone & Specialized Therapies</h3>
  <ul>
    <li>Hormone replacement therapy (HRT) — personalized programs for energy, balance, and well-being.</li>
    <li>Medical weight loss programs — structured, safe approaches under medical supervision.</li>
    <li>Prescription weight loss medications — prescribed when appropriate to support weight management.</li>
    <li>Weight loss & metabolic health — improving metabolism for long-term results.</li>
  </ul>

  <h3>Mental & Behavioral Health</h3>
  <ul>
    <li>Mental health & behavioral care — holistic support for emotional well-being.</li>
    <li>Anxiety & depression management — evidence-based treatments for stability and relief.</li>
    <li>ADHD assessment & treatment — accurate diagnosis and tailored support plans.</li>
    <li>Sleep disorder management — solutions for better rest and daily performance.</li>
  </ul>

  <h3>Minor Procedures</h3>
  <ul>
    <li>Ear lobe repair — restoring ear shape after damage or stretching.</li>
    <li>Cyst removal — safe, minor surgical procedure in office.</li>
  </ul>

  <h3>Additional Services We Offer</h3>
  <ul>
    <li>Telemedicine consultations — secure virtual visits from anywhere.</li>
    <li>IV therapy & vitamin infusions — boosting energy, immunity, and hydration.</li>
    <li>Dermatology & skin care (acne, rashes, mole removals) — clear skin with medical guidance.</li>
    <li>Sexual health services (STD testing, hormone therapy) — confidential and professional care.</li>
    <li>Smoking cessation programs — personalized support to help you quit for good.</li>
  </ul>
  <p>“From children to adults, our bilingual team is here to provide accessible, personalized care for every stage of life. Book your consultation today.”</p>
</template>

<script>
export default {
  name: 'ContentEn'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
